var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLogFiles = function SvgIconLogFiles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 500 500",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_log_files_svg2__a",
    x1: 54.66,
    x2: 442.85,
    y1: 484.44,
    y2: 86.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_log_files_svg2__a",
    id: "icon_log_files_svg2__b",
    x1: -58.33,
    x2: 329.86,
    y1: 374.23,
    y2: -23.75
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_log_files_svg2__a",
    id: "icon_log_files_svg2__c",
    x1: -37.5,
    x2: 350.69,
    y1: 394.54,
    y2: -3.44
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_log_files_svg2__a",
    id: "icon_log_files_svg2__d",
    x1: 4.68,
    x2: 392.87,
    y1: 435.68,
    y2: 37.7
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_log_files_svg2__a",
    id: "icon_log_files_svg2__e",
    x1: 25.5,
    x2: 413.7,
    y1: 456,
    y2: 58.02
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_log_files_svg2__a",
    id: "icon_log_files_svg2__f",
    x1: 46.33,
    x2: 434.52,
    y1: 476.31,
    y2: 78.33
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_log_files_svg2__a",
    id: "icon_log_files_svg2__g",
    x1: 120.54,
    x2: 508.73,
    y1: 548.69,
    y2: 150.71
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_log_files_svg2__a",
    id: "icon_log_files_svg2__h",
    x1: 141.36,
    x2: 529.56,
    y1: 569.01,
    y2: 171.03
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_log_files_svg2__a",
    id: "icon_log_files_svg2__i",
    x1: 162.19,
    x2: 550.38,
    y1: 589.32,
    y2: 191.34
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_log_files_svg2__a",
    id: "icon_log_files_svg2__j",
    x1: 183.02,
    x2: 571.21,
    y1: 609.64,
    y2: 211.66
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_log_files_svg2__a",
    id: "icon_log_files_svg2__k",
    x1: 203.84,
    x2: 592.04,
    y1: 629.95,
    y2: 231.97
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_log_files_svg2__a",
    id: "icon_log_files_svg2__l",
    x1: 44.75,
    x2: 432.95,
    y1: 474.78,
    y2: 76.79
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_log_files_svg2__a",
    id: "icon_log_files_svg2__m",
    x1: 8.46,
    x2: 396.65,
    y1: 439.37,
    y2: 41.39
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_log_files_svg2__a",
    id: "icon_log_files_svg2__n",
    x1: 87.46,
    x2: 475.65,
    y1: 516.43,
    y2: 118.45
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M481.21 80.25c-.08-.18-.17-.35-.28-.52a24.9 24.9 0 0 0-4.93-7.17L410.78 7.33a24.7 24.7 0 0 0-7.17-4.93c-.16-.1-.34-.2-.52-.28A24.8 24.8 0 0 0 393.08 0H116.67C98.26 0 83.33 14.92 83.33 33.33v233.33h-50c-9.2 0-16.67 7.46-16.67 16.67v150c0 9.2 7.46 16.67 16.67 16.67h50v16.67c0 18.41 14.92 33.33 33.33 33.33h333.33c18.41 0 33.33-14.92 33.33-33.33V90.25c0-3.44-.73-6.85-2.12-10Zm-72.88-51.8L454.88 75h-22.55c-13.25-.01-23.99-10.75-24-24zm-375 404.88v-150H300v150zm433.34 33.34c0 9.2-7.46 16.67-16.67 16.67H116.67c-9.2 0-16.67-7.46-16.67-16.67V450h200c9.2 0 16.67-7.46 16.67-16.67v-150c0-9.2-7.46-16.67-16.67-16.67H100V33.33c0-9.2 7.46-16.67 16.67-16.67h275v34.33c.02 22.45 18.22 40.64 40.67 40.67h34.33v375Z",
    style: {
      fill: "url(#icon_log_files_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.67 75h200a8.33 8.33 0 0 0 0-16.66h-200a8.33 8.33 0 0 0 0 16.66",
    style: {
      fill: "url(#icon_log_files_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.67 116.67h200a8.33 8.33 0 0 0 0-16.66h-200a8.33 8.33 0 0 0 0 16.66",
    style: {
      fill: "url(#icon_log_files_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425 141.67H141.67a8.33 8.33 0 0 0 0 16.66H425a8.33 8.33 0 0 0 0-16.66",
    style: {
      fill: "url(#icon_log_files_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425 183.33H141.67a8.33 8.33 0 0 0 0 16.66H425a8.33 8.33 0 0 0 0-16.66",
    style: {
      fill: "url(#icon_log_files_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425 225H141.67a8.33 8.33 0 0 0 0 16.66H425a8.33 8.33 0 0 0 0-16.66",
    style: {
      fill: "url(#icon_log_files_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425 266.67h-75a8.33 8.33 0 0 0 0 16.66h75a8.33 8.33 0 0 0 0-16.66",
    style: {
      fill: "url(#icon_log_files_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425 308.33h-75a8.33 8.33 0 0 0 0 16.66h75a8.33 8.33 0 0 0 0-16.66",
    style: {
      fill: "url(#icon_log_files_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425 350h-75a8.33 8.33 0 0 0 0 16.66h75a8.33 8.33 0 0 0 0-16.66",
    style: {
      fill: "url(#icon_log_files_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425 391.67h-75a8.33 8.33 0 0 0 0 16.66h75a8.33 8.33 0 0 0 0-16.66",
    style: {
      fill: "url(#icon_log_files_svg2__j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425 433.33h-75a8.33 8.33 0 0 0 0 16.66h75a8.33 8.33 0 0 0 0-16.66",
    style: {
      fill: "url(#icon_log_files_svg2__k)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.33 308.33c-18.41 0-33.33 14.92-33.33 33.33v33.33c0 18.41 14.92 33.33 33.33 33.33s33.33-14.92 33.33-33.33v-33.33c0-18.41-14.92-33.33-33.33-33.33M175 375c0 9.2-7.46 16.67-16.67 16.67s-16.67-7.46-16.67-16.67v-33.33c0-9.2 7.46-16.67 16.67-16.67S175 332.46 175 341.67z",
    style: {
      fill: "url(#icon_log_files_svg2__l)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.33 391.67H75v-75a8.33 8.33 0 0 0-16.66 0v75c0 9.2 7.46 16.67 16.67 16.67h33.33a8.33 8.33 0 0 0 0-16.66Z",
    style: {
      fill: "url(#icon_log_files_svg2__m)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.67 358.33H250a8.33 8.33 0 0 0 0 16.66h8.33c0 9.2-7.46 16.67-16.67 16.67s-16.67-7.46-16.67-16.67v-33.33c-.02-9.2 7.43-16.68 16.63-16.7 7.09-.02 13.41 4.46 15.76 11.14 1.71 4.27 6.57 6.34 10.84 4.63 4.02-1.61 6.13-6.04 4.86-10.18-6.14-17.36-25.19-26.45-42.54-20.31-13.31 4.71-22.21 17.3-22.22 31.42v33.33c0 18.41 14.92 33.33 33.33 33.33s33.33-14.92 33.33-33.33v-8.33c0-4.6-3.73-8.33-8.33-8.33Z",
    style: {
      fill: "url(#icon_log_files_svg2__n)"
    }
  }));
};
export default SvgIconLogFiles;